"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpectrum = void 0;
var _react = require("react");
var _context = require("./context");
const useSpectrum = () => {
  return (0, _react.useContext)(_context.SpectrumContext);
};
exports.useSpectrum = useSpectrum;